module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Navigation/Up-down-aca35d51b6e1bb600da700ff73997788.svg";